import React from 'react'
import { defaultProps } from './index'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'

export const DownloadLinkSettings = (settingsProps) => {
  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="url"
          type="file"
          label="File"
          defaultValue={defaultProps['url']}
        />
      </ToolbarSection>
    </>
  )
}

export const DownloadLinkFloatingSettings = () =>
  React.createElement(DownloadLinkSettings, { floating: true })
